import styled from "styled-components";
import { Switch } from "./Switch";

export const SwitchRow = ({
    icon,
    title,
    description,
    isChecked = false,
    onChange,
    ...restProps
}) => {
    return (
        <StyledSwitchRow $isChecked={isChecked} {...restProps}>
            {
                icon ? <div className="iconContainer"> {icon} </div> : null
            }
            
            <div className="content">
                <span className="switchBoxTitle">{title}</span>
                {description ? <span className="switchBoxDescription">{description}</span> : null}
            </div>
            <div className="switchContainer">
                <Switch isChecked={isChecked} onChange={onChange}/>
            </div>
            
        </StyledSwitchRow>
    )
}

const StyledSwitchRow = styled.label`
    border-radius: ${({theme}) => theme.cornerRadius.md};
    //border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    border: 1px solid ${({theme, $isChecked}) => $isChecked ? theme.colors.neutralSecondaryForeground : theme.colors.neutralPrimaryBorder};
    
    padding: ${({theme}) => theme.spacing.md};
    display: flex;
    gap: ${({theme}) => theme.spacing.md};
    align-items: stretch;
    cursor: pointer;
    user-select: none;
    

    div.iconContainer
    {
        width: 38px;
        height: 38px;
        //background: ${({theme}) => theme.colors.neutralPrimaryBorder};
        background: ${({theme, $isChecked}) => $isChecked ? theme.colors.neutralSecondaryForeground : theme.colors.mutedForeground};
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 38px;
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        transition-duration: 110ms;
        color: ${({theme}) => theme.colors.neutralPrimaryBackground};

        .icon
        {
            font-size: ${({theme}) => theme.iconSize.lg};
        }
    }

    div.content
    {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: ${({theme}) => theme.spacing.sm};
        transition-duration: 110ms;
        color: ${({theme, $isChecked}) => $isChecked ? theme.colors.neutralSecondaryForeground : theme.colors.mutedForeground};

        span.switchBoxTitle
        {
            font-weight: 600;
        }

        &:has(.switchBoxDescription)
        {
            justify-content: flex-start;
        }
        
    }

    div.switchContainer
    {
        flex: 0 0 38px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`